/* Persona display metadata — generated by sales-academy-factory. What the
 * dashboard needs to render persona tiles + briefing strips. */
import type { PersonaKey } from '@/constants/avatars';

export type PaletteRole = 'warmth' | 'growth' | 'danger';

export interface PersonaPronouns {
  subject: 'she' | 'he';
  object: 'her' | 'him';
  possessive: 'her' | 'his';
}

export interface PersonaMeta {
  key: PersonaKey;
  display_name: string;
  short_label: string;
  role_line: string;
  color_key: PaletteRole;
  unlock_hint: string;
  pronouns: PersonaPronouns;
  retry_hook: string;
}

export const PERSONAS_SEED: Record<PersonaKey, PersonaMeta> = {
  dan: {
    key: 'dan',
    display_name: 'Dan Kowalski',
    short_label: 'Self-employed contractor shopping buyer\'s agents on commission rate, convinced all realtors offer identical service.',
    role_line: '44 · Self-employed contractor shopping buyer\'s agents on commission rate, convinced all realtors offer identical service.',
    color_key: 'growth',
    unlock_hint: 'Your starting persona.',
    pronouns: { subject: 'he', object: 'him', possessive: 'his' },
    retry_hook: 'Handling price-first objections by leading with targeted discovery questions that expose unmet criteria and prior negative experiences, then anchoring commission value to concrete, industry-specific procedural differentiators rather than generic claims of superior service.',
  },
  rita: {
    key: 'rita',
    display_name: 'Rita Solano',
    short_label: 'Retired administrator; listing expired after agent overpriced by $47K and stopped returning calls after month two.',
    role_line: '58 · Retired administrator; listing expired after agent overpriced by $47K and stopped returning calls after month two.',
    color_key: 'danger',
    unlock_hint: 'Unlocks after Module 1.',
    pronouns: { subject: 'she', object: 'her', possessive: 'her' },
    retry_hook: 'Rebuilding seller trust after a prior agent\'s ethical failure by combining fiduciary accountability, data-grounded pricing discipline, and a concrete written service commitment — without flattery, false urgency, or price inflation.',
  },
  maya: {
    key: 'maya',
    display_name: 'Maya Osei',
    short_label: 'Pediatric nurse pre-approved for $340K, emotionally committed to a $389K home, hoping the agent will say it\'s fine.',
    role_line: '31 · Pediatric nurse pre-approved for $340K, emotionally committed to a $389K home, hoping the agent will say it\'s fine.',
    color_key: 'danger',
    unlock_hint: 'Unlocks after Module 3.',
    pronouns: { subject: 'she', object: 'her', possessive: 'her' },
    retry_hook: 'Suitability-first advisory restraint: the rep must resist the social and financial pressure to validate an emotionally driven overreach, surface concrete financial risk using real numbers, and protect a vulnerable first-time buyer\'s long-term wellbeing even when doing so jeopardizes the transaction.',
  },
  tyler: {
    key: 'tyler',
    display_name: 'Tyler Brandt',
    short_label: 'IT support tech at his first open house, pre-approved last week, ready to offer tonight with no buyer-agency knowledge.',
    role_line: '27 · IT support tech at his first open house, pre-approved last week, ready to offer tonight with no buyer-agency knowledge.',
    color_key: 'warmth',
    unlock_hint: 'Unlocks after Module 3.',
    pronouns: { subject: 'he', object: 'him', possessive: 'his' },
    retry_hook: 'Slowing an emotionally over-committed first-time buyer to conduct real discovery, explain mandatory agency disclosures and material property facts, and surface financial and suitability risks before offer momentum overrides due diligence — without extinguishing the client\'s enthusiasm or manufacturing false urgency.',
  },
};

export const PERSONA_ORDER: PersonaKey[] = ['dan', 'rita', 'maya', 'tyler'];
